"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewComment = void 0;
const react_1 = __importStar(require("react"));
require("./NewPostInput.css");
const utilities_1 = require("../../utilities");
const material_1 = require("@mui/material");
const Send_1 = __importDefault(require("@mui/icons-material/Send"));
const NewCommentInput = (props) => {
    const [value, setValue] = (0, react_1.useState)("");
    // called whenever the user types in the new comment input box
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    // called when the user hits "Submit" for a new post
    const handleSubmit = (event) => {
        event.preventDefault();
        props.onSubmit && props.onSubmit(value);
        setValue("");
    };
    return (react_1.default.createElement("div", { className: "NewPostInput-container u-flex" },
        react_1.default.createElement("input", { type: "text", placeholder: props.defaultText, value: value, onChange: handleChange, className: "NewPostInput-input" }),
        react_1.default.createElement(material_1.Button, { type: "submit", className: "NewPostInput-button u-pointer", value: "Submit", onClick: handleSubmit, disableElevation: true, variant: "contained", endIcon: react_1.default.createElement(Send_1.default, null), sx: { borderRadius: "0 4px 4px 0", cursor: "pointer" } }, "Submit")));
};
const NewComment = (props) => {
    const addComment = (value) => {
        (0, utilities_1.post)(`/api/foodevents/${props.foodeventId}/comments/new`, { content: value })
            .then((comment) => {
            props.addNewComment(comment);
        })
            .catch(console.error);
    };
    return react_1.default.createElement(NewCommentInput, { defaultText: "New Comment", onSubmit: addComment });
};
exports.NewComment = NewComment;
